import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { Container, TableHead, Typography } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import { Menu, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import { TextField } from "@mui/material";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { ReactComponent as ExpandMoreIcon } from "../../icons/ExpandMore24.svg";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";

import AccordionTitle from "../../components/AccordionTitle";
import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import isEmpty from "lodash-es/isEmpty";
import dayjs from "dayjs";

import { doService } from "../../services/ServiceHelper";
import {
  createUserList,
  deleteUserList,
  makeUserListGlobal,
  getTeacherUserLists,
  shareUserList,
  updateUserList,
  isAdmin,
  getUserEid,
  getUserPriority,
} from "../../services/UserService";
import { getSchoolTeachers } from "../../services/SchoolService";
import SelectTeachersDialog from "../../components/faculty/SelectTeachersDialog";
import {
  StripedTableCell,
  StripedTableHeadCell,
  StripedTableRow,
} from "../../components/StripedTable";
import TableRowNoResults from "../../components/TableRowNoResults";

const ManageStudentLists = () => {
  const navigate = useNavigate();

  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);

  const [_myStudentLists, setMyStudentLists] = useState([]);
  const [_sharedStudentLists, setSharedStudentLists] = useState([]);
  const [_unsharedStudentLists, setUnsharedStudentLists] = useState([]);
  const [_globalStudentLists, setGlobalStudentLists] = useState([]);

  const [_dialogOpenDetail, setDialogOpenDetail] = useState(false);
  const [_dialogOpenShare, setDialogOpenShare] = useState(false);
  const [_dialogOpenCreate, setDialogOpenCreate] = useState(false);
  const [_selectedList, setSelectedList] = useState({});
  const [_teachers, setTeachers] = useState([]);

  const [_newName, setNewName] = useState("");
  const [_newDescription, setNewDescription] = useState("");
  const [_isGlobal, setIsGlobal] = useState(false);

  const [_userPriority] = useState(getUserPriority(_jwt));

  useEffect(() => {
    initStudentLists();
    initTeachers();
  }, []);

  const initTeachers = () => {
    doService(getSchoolTeachers(_school, _jwt), (results) => {
      const labeledLists = [];
      for (const teachers of results.data) {
        labeledLists.push({
          label: teachers.last_name + ", " + teachers.first_name,
          value: teachers.eid,
        });
      }
      setTeachers(labeledLists);
    });
  };

  const initStudentLists = () => {
    setShowProgress(true);
    doService(getTeacherUserLists(_school, _jwt), (results) => {
      const mine = [];
      const sharedTeacherLists = [];
      const globals = [];
      const unsharedTeacherLists = [];

      const myUserEid = getUserEid(_jwt);
      console.log(myUserEid);

      for (const list of results.data) {
        if (list.userEid === myUserEid && list.isShared === 0) {
          // make sure the shared ones only land in the shared section
          mine.push(list);
        }
        if (list.isShared === 1) {
          // not mine but shared
          sharedTeacherLists.push(list);
        } else if (list.isShared === 0 && list.isGlobal === 0) {
          // not mine and not shared (could be shared)
          unsharedTeacherLists.push(list);
        }
        if (list.isGlobal === 1) {
          globals.push(list);
        }
      }

      setMyStudentLists(mine);
      setSharedStudentLists(sharedTeacherLists);
      setUnsharedStudentLists(unsharedTeacherLists);
      setGlobalStudentLists(globals);

      setShowProgress(false);
    });
  };

  const handleClickCreate = () => {
    setNewDescription("");
    setNewName("");
    setIsGlobal(false);
    setDialogOpenCreate(true);
  };

  const handleClickDetails = (list) => {
    setSelectedList(list);
    setDialogOpenDetail(true);
  };

  const handleClickStudents = (list) => {
    navigate(`/teacher/student-list/${list.eid}`);
  };

  const handleClickQrPdf = (list) => {
    navigate(`/teacher/student-list-qr/${list.eid}`);
  };

  const handleClickRename = (list) => {
    let name = window.prompt("Please enter the new Student List name.");

    if (isEmpty(name)) {
      return;
    }

    setShowProgress(true);
    doService(updateUserList(_school, _jwt, list.id, name), (results) => {
      initStudentLists();
      setShowProgress(false);
      window.showSnack("User List Renamed");
    });
  };

  const handleClickShare = (list) => {
    setSelectedList(list);
    setDialogOpenShare(true);
  };

  const handleClickDelete = (list) => {
    if (!window.confirm("Click OK to confirm delete, or Cancel.")) {
      return;
    }

    setShowProgress(true);
    doService(deleteUserList(_school, _jwt, list.id), (results) => {
      initStudentLists();
      setShowProgress(false);
      window.showSnack("User List Deleted");
    });
  };

  const handleClickMakeGlobal = (list) => {
    if (
      !window.confirm(
        "Click OK to make the list global to ALL teachers, or Cancel."
      )
    ) {
      return;
    }

    setShowProgress(true);
    doService(makeUserListGlobal(_school, _jwt, list.id, true), (results) => {
      initStudentLists();
      setShowProgress(false);
      window.showSnack("User List is Now Global");
    });
  };

  const handleClickMakeUnGlobal = (list) => {
    if (
      !window.confirm("Click OK to make the list no longer global, or Cancel.")
    ) {
      return;
    }

    setShowProgress(true);
    doService(makeUserListGlobal(_school, _jwt, list.id, false), (results) => {
      initStudentLists();
      setShowProgress(false);
      window.showSnack("User List is no longer Global");
    });
  };

  const handleCloseDialogShare = () => setDialogOpenShare(false);

  const handleOKShare = (items) => {
    setDialogOpenShare(false);
    const teacherEids = [];

    if (items.length === 0) {
      return;
    }

    for (const item of items) {
      teacherEids.push(item.value);
    }

    setShowProgress(true);
    doService(
      shareUserList(_school, _jwt, _selectedList.eid, teacherEids),
      (results) => {
        setShowProgress(false);
        window.showSnack("Shared Student List to Teachers");
      }
    );
  };

  const handleClickSave = () => {
    if (isEmpty(_newName)) {
      alert("Please enter Student List Name.");
      return;
    }

    setDialogOpenCreate(false);
    setShowProgress(true);
    doService(
      createUserList(_school, _jwt, _newName, _newDescription, _isGlobal),
      (results) => {
        setShowProgress(false);
        window.showSnack("Student List Created");

        // redirect to add students
        navigate(`/teacher/student-list/${results.data.eid}`);
      }
    );
  };

  const handleClickImportStudents = (list) => {
    navigate(`/teacher/student-list/${list.eid}`);
  };

  const handleChangeIsGlobal = (event) => {
    const isChecked = event.target.checked;
    setIsGlobal(isChecked);
  };

  const handleClickGenerateQrSheet = (list) => {
    navigate(`/teacher/student-list/${list.eid}/qr`);
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Manage Student Lists" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Alert severity="info" sx={{ mt: 1, mb: 1 }}>
          Click on the Student List name on the left column to view and edit in
          the right column.
        </Alert>

        <Button
          sx={{ mt: 1 }}
          variant="contained"
          onClick={handleClickCreate}
        >
          Create Student List
        </Button>

        <Accordion disableGutters sx={{ boxShadow: 1, p: 0, mt: 2 }}>
          <AccordionSummary
            className="accordionHeader"
            expandIcon={<ExpandMoreIcon />}
          >
            <AccordionTitle
              text={`My Student Lists (${_myStudentLists.length})`}
            />
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper} sx={{ mt: 1, mb: 1 }}>
              <Table size="small">
                <TableHead>
                  <StripedTableRow>
                    <StripedTableCell>Name</StripedTableCell>
                    <StripedTableCell align="center" width={120}>
                      Created
                    </StripedTableCell>
                    <StripedTableCell align="center" width={120}>
                      Actions
                    </StripedTableCell>
                  </StripedTableRow>
                </TableHead>
                <TableBody>
                  <TableRowNoResults data={_myStudentLists} />
                  {_myStudentLists.map((list) => (
                    <StripedTableRow key={list.id}>
                      <StripedTableCell>
                        {list.name}
                        {list.isGlobal === 1 && <> (GLOBAL)</>}
                        {list.isShared === 1 && <> (SHARED)</>}
                      </StripedTableCell>
                      <StripedTableCell align="center">
                        {dayjs(list.dateCreated).format("MM/DD/YY")}
                      </StripedTableCell>
                      <StripedTableCell width={100} align="center">
                        {" "}
                        <Menu menuButton={<Button>Actions</Button>} transition>
                          <MenuItem
                            value={list.id}
                            onClick={() => handleClickDetails(list)}
                          >
                            Details
                          </MenuItem>
                          <MenuItem
                            value={list.id}
                            onClick={() => handleClickStudents(list)}
                          >
                            Students
                          </MenuItem>
                          {/* <MenuItem
                            value={list.id}
                            onClick={() => handleClickQrPdf(list)}
                          >
                            Generate QR PDF
                          </MenuItem> */}
                          {(list.isGlobal === 0 || isAdmin(_jwt)) && (
                            <>
                              <MenuItem
                                value={list.id}
                                onClick={() => handleClickRename(list)}
                              >
                                Rename
                              </MenuItem>
                              <MenuItem
                                value={list.id}
                                onClick={() => handleClickShare(list)}
                              >
                                Share
                              </MenuItem>
                              <MenuItem
                                value={list.id}
                                onClick={() => handleClickDelete(list)}
                              >
                                Delete
                              </MenuItem>
                            </>
                          )}
                          <MenuItem
                            value={list.id}
                            onClick={() => handleClickGenerateQrSheet(list)}
                          >
                            Generate QR Sheet
                          </MenuItem>
                          <MenuItem
                            value={list.id}
                            onClick={() => handleClickImportStudents(list)}
                          >
                            Import Students (XLSX)
                          </MenuItem>
                        </Menu>
                      </StripedTableCell>
                    </StripedTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Accordion disableGutters sx={{ boxShadow: 1, p: 0, mt: 2 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordionHeader"
          >
            <AccordionTitle
              text={`Shared Lists (${_sharedStudentLists.length})`}
            />
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper} sx={{ mt: 1, mb: 1 }}>
              <Table size="small">
                <TableHead>
                  <StripedTableRow>
                    <StripedTableCell>Name</StripedTableCell>
                    <StripedTableCell>Owner</StripedTableCell>
                    <StripedTableCell width={120} align="center">
                      Created
                    </StripedTableCell>
                    <StripedTableCell align="center" width={120}>
                      Actions
                    </StripedTableCell>
                  </StripedTableRow>
                </TableHead>{" "}
                <TableBody>
                  <TableRowNoResults data={_sharedStudentLists} />
                  {_sharedStudentLists.map((list) => (
                    <StripedTableRow key={list.id}>
                      <StripedTableCell>
                        {list.name}
                        {list.isGlobal === 1 && <> (GLOBAL)</>}
                      </StripedTableCell>
                      <StripedTableCell>
                        {list.last_name}, {list.first_name}
                      </StripedTableCell>
                      <StripedTableCell align="center">
                        {dayjs(list.dateCreated).format("MM/DD/YY")}
                      </StripedTableCell>
                      <StripedTableCell width={100} align="center">
                        <Menu menuButton={<Button>Actions</Button>} transition>
                          <MenuItem
                            value={list.id}
                            onClick={() => handleClickDetails(list)}
                          >
                            Details
                          </MenuItem>
                          <MenuItem
                            value={list.id}
                            onClick={() => handleClickStudents(list)}
                          >
                            Students
                          </MenuItem>
                          {isAdmin(_jwt) && (
                            <>
                              <MenuItem
                                value={list.id}
                                onClick={() => handleClickRename(list)}
                              >
                                Rename
                              </MenuItem>
                              <MenuItem
                                value={list.id}
                                onClick={() => handleClickShare(list)}
                              >
                                Share
                              </MenuItem>
                              <MenuItem
                                value={list.id}
                                onClick={() => handleClickDelete(list)}
                              >
                                Delete
                              </MenuItem>
                            </>
                          )}
                          <MenuItem
                            value={list.id}
                            onClick={() => handleClickGenerateQrSheet(list)}
                          >
                            Generate QR Sheet
                          </MenuItem>
                        </Menu>
                      </StripedTableCell>
                    </StripedTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Accordion disableGutters sx={{ boxShadow: 1, p: 0, mt: 2 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordionHeader"
          >
            <AccordionTitle
              text={`Global Lists (${_globalStudentLists.length})`}
            />
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper} sx={{ mt: 1, mb: 1 }}>
              <Table size="small">
                <TableHead>
                  <StripedTableRow>
                    <StripedTableCell>Name</StripedTableCell>
                    <StripedTableCell>Owner</StripedTableCell>
                    <StripedTableCell align="center" width={120}>
                      Created
                    </StripedTableCell>
                    <StripedTableCell align="center" width={120}>
                      Actions
                    </StripedTableCell>
                  </StripedTableRow>
                </TableHead>{" "}
                <TableBody>
                  <TableRowNoResults data={_globalStudentLists} />
                  {_globalStudentLists.map((list) => (
                    <StripedTableRow key={list.id}>
                      <StripedTableCell>
                        {list.name}
                        {list.isGlobal === 1 && <> (GLOBAL)</>}
                      </StripedTableCell>
                      <StripedTableCell>
                        {list.last_name != null && (
                          <>
                            {list.last_name}, {list.first_name.substring(0, 1)}
                          </>
                        )}
                        {list.last_name == null && "-- ADMIN --"}
                      </StripedTableCell>
                      <StripedTableCell align="center">
                        {dayjs(list.dateCreated).format("MM/DD/YY")}
                      </StripedTableCell>
                      <StripedTableCell width={100} align="center">
                        <Menu menuButton={<Button>Actions</Button>} transition>
                          <MenuItem
                            value={list.id}
                            onClick={() => handleClickDetails(list)}
                          >
                            Details
                          </MenuItem>
                          <MenuItem
                            value={list.id}
                            onClick={() => handleClickStudents(list)}
                          >
                            Students
                          </MenuItem>
                          {isAdmin(_jwt) && (
                            <>
                              <MenuItem
                                value={list.id}
                                onClick={() => handleClickRename(list)}
                              >
                                Rename
                              </MenuItem>
                              <MenuItem
                                value={list.id}
                                onClick={() => handleClickShare(list)}
                              >
                                Share
                              </MenuItem>
                              <MenuItem
                                value={list.id}
                                onClick={() => handleClickGenerateQrSheet(list)}
                              >
                                Generate QR Sheet
                              </MenuItem>
                              <MenuItem
                                value={list.id}
                                onClick={() => handleClickMakeUnGlobal(list)}
                              >
                                Make UN-Global
                              </MenuItem>
                              <MenuItem
                                value={list.id}
                                onClick={() => handleClickDelete(list)}
                              >
                                Delete
                              </MenuItem>
                            </>
                          )}
                        </Menu>
                      </StripedTableCell>
                    </StripedTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        {_userPriority === 800 && (
          <Accordion disableGutters sx={{ boxShadow: 1, p: 0, mt: 2 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              className="accordionHeader"
            >
              <AccordionTitle
                text={`Unshared Teacher Lists (${_unsharedStudentLists.length})`}
              />
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper} sx={{ mt: 1, mb: 1 }}>
                <Table size="small">
                  <TableHead>
                    <StripedTableRow>
                      <StripedTableCell>Name</StripedTableCell>
                      <StripedTableCell>Owner</StripedTableCell>
                      <StripedTableCell width={120} align="center">
                        Created
                      </StripedTableCell>
                      <StripedTableCell align="center" width={120}>
                        Actions
                      </StripedTableCell>
                    </StripedTableRow>
                  </TableHead>
                  <TableBody>
                    <TableRowNoResults data={_unsharedStudentLists} />
                    {_unsharedStudentLists.map((list) => (
                      <StripedTableRow key={list.id}>
                        <StripedTableCell>
                          {list.name}
                          {list.isGlobal === 1 && <> (GLOBAL)</>}
                        </StripedTableCell>
                        <StripedTableCell>
                          {list.last_name != null && (
                            <>
                              {list.last_name},{" "}
                              {list.first_name.substring(0, 1)}
                            </>
                          )}
                          {list.last_name == null && <>--N/A--</>}
                        </StripedTableCell>
                        <StripedTableCell align="center">
                          {dayjs(list.dateCreated).format("MM/DD/YY")}
                        </StripedTableCell>
                        <StripedTableCell width={100} align="center">
                          {" "}
                          <Menu
                            menuButton={<Button>Actions</Button>}
                            transition
                          >
                            <MenuItem
                              value={list.id}
                              onClick={() => handleClickDetails(list)}
                            >
                              Details
                            </MenuItem>
                            <MenuItem
                              value={list.id}
                              onClick={() => handleClickStudents(list)}
                            >
                              Students
                            </MenuItem>
                            {isAdmin(_jwt) && (
                              <>
                                <MenuItem
                                  value={list.id}
                                  onClick={() => handleClickRename(list)}
                                >
                                  Rename
                                </MenuItem>
                                <MenuItem
                                  value={list.id}
                                  onClick={() => handleClickShare(list)}
                                >
                                  Share
                                </MenuItem>
                                <MenuItem
                                  value={list.id}
                                  onClick={() => handleClickMakeGlobal(list)}
                                >
                                  Make Global
                                </MenuItem>
                                <MenuItem
                                  value={list.id}
                                  onClick={() =>
                                    handleClickGenerateQrSheet(list)
                                  }
                                >
                                  Generate QR Sheet
                                </MenuItem>
                                <MenuItem
                                  value={list.id}
                                  onClick={() => handleClickDelete(list)}
                                >
                                  Delete
                                </MenuItem>
                              </>
                            )}
                          </Menu>
                        </StripedTableCell>
                      </StripedTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        )}
      </Container>

      <Dialog fullWidth={true} open={_dialogOpenDetail}>
        <DialogTitle sx={{ p: 1 }}>Student List Details</DialogTitle>
        <DialogContent sx={{ pb: 0 }}>
          <Accordion disableGutters sx={{ boxShadow: 1, p: 0, mt: 2 }} expanded>
            <AccordionSummary className="accordionTitle">
              Summary
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer component={Paper} sx={{ mt: 1, mb: 1 }}>
                <Table size="small">
                  <TableBody>
                    <StripedTableRow>
                      <StripedTableHeadCell>Student List Name</StripedTableHeadCell>
                      <StripedTableCell>{_selectedList.name}</StripedTableCell>
                    </StripedTableRow>
                    <StripedTableRow>
                      <StripedTableHeadCell>Description</StripedTableHeadCell>
                      <StripedTableCell>{isEmpty(_selectedList.description) ? "-- NONE --" : _selectedList.description}</StripedTableCell>
                    </StripedTableRow>
                    <StripedTableRow>
                      <StripedTableHeadCell>Owner</StripedTableHeadCell>
                      <StripedTableCell>{_selectedList.last_name}, {_selectedList.first_name}</StripedTableCell>
                    </StripedTableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>

          {/* <Accordion disableGutters sx={{ boxShadow: 1, p: 0, mt: 2 }} expanded>
            <AccordionSummary className="accordionTitle">
              Shared With
            </AccordionSummary>
            <AccordionDetails>
            </AccordionDetails>
            </Accordion> */}
          <br />

        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              setDialogOpenDetail(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog fullWidth={true} open={_dialogOpenCreate}>
        <DialogTitle sx={{ p: 1 }}>Create Student List</DialogTitle>
        <DialogContent sx={{ pb: 0 }}>
          <InputLabel>Student List Name *:</InputLabel>
          <TextField
            margin="dense"
            type="text"
            fullWidth
            variant="outlined"
            size="small"
            onChange={(event) => setNewName(event.target.value)}
            placeholder="Required Field"
            value={_newName}
          />
          <InputLabel>Description (optional):</InputLabel>
          <TextField
            margin="dense"
            type="text"
            fullWidth
            variant="outlined"
            size="small"
            onChange={(event) => setNewDescription(event.target.value)}
            placeholder="Optional Field"
            value={_newDescription}
          />

          {isAdmin(_jwt) && (
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(event) => handleChangeIsGlobal(event)}
                  checked={_isGlobal}
                />
              }
              label={"Is Global List"}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              setDialogOpenCreate(false);
            }}
          >
            Cancel
          </Button>
          <Button onClick={handleClickSave} variant="contained">
            SAVE
          </Button>
        </DialogActions>
      </Dialog>

      <SelectTeachersDialog
        open={_dialogOpenShare}
        onClose={handleCloseDialogShare}
        onOK={handleOKShare}
        teachers={_teachers}
      />
    </>
  );
};

export default ManageStudentLists;
